<template>
  <div class="secondary  py-lg-16 py-xl-16  pb-9">
    <div class="w-80 ma-auto">

      <v-row>
        <v-col @click="$router.push('/sub/glass/technical/catalogue')" class="text-center" cols="12" xl="4" lg="4" v-if="catalogue.topics!=undefined">
          <h2 class="py-3 gray--text  font-weight-bold">{{$t('catalogue')}}</h2>
          <img class="rounded-lg" width="90%" height="300" :src="catalogue.topics[itemImage].photo_file" alt="">
          <!--          <div class="selected-item" v-for="(item,index) in catalogue.topics" :key="index">
                      <v-icon  color="success" size="15" class="ml-3 link-decor">mdi-circle</v-icon>
                      <h5 class="gray&#45;&#45;text" @mouseover="itemImage=index">{{ item.title }}</h5>
                    </div>-->
          <!--          <div class="text-center w-100">
                      <h5 class="py-2 success&#45;&#45;text ">{{ $t('more') }}</h5>
                    </div>-->


        </v-col>
        <v-col  @click="$router.push('/sub/glass/news/gallery')"  class="text-center" cols="12" xl="4" lg="4">
          <h2 class="py-3 gray--text  font-weight-bold">{{$t('video')}}</h2>
          <img class="rounded-lg" width="90%" height="300" :src="videos[itemVideo].image" alt="">
          <!--          <div class="selected-item" v-for="(item,index) in videos" :key="index">
                      <v-icon color="success" size="15" class="ml-3 link-decor">mdi-circle</v-icon>
                      <h5 class="gray&#45;&#45;text" @mouseover="itemVideo=index">{{ item.title }}</h5>
                    </div>-->
          <!--          <h4 class="py-2 success&#45;&#45;text selected-item">{{$t('more')}}</h4>-->
          <!--<v-btn  class="mt-2 px-9 mr-7" color="success" depressed>
            <h6 class="py-2 white&#45;&#45;text ">{{$t('more')}}</h6>
          </v-btn>-->

        </v-col>
        <v-col @click="$router.push('/sub/glass/technical/articles')" class="text-center" cols="12" xl="4" lg="4" v-if="articles.topics!=undefined">
          <h2 class="py-3 gray--text font-weight-bold">{{$t('article')}}</h2>
          <img class="rounded-lg" width="90%" height="300" :src="articles.topics[itemBlog].photo_file" alt="">
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'mainGLassDownloads',
  data() {
    return {
      itemImage: 0,
      itemVideo: 0,
      itemBlog: 0,
      catalogs: [
        {
          image: require('../../../../assets/images/product-images/material.jpg'),
          title: 'دانلود کاتالوگ'
        },
        {
          image: require('../../../../assets/images/product-images/masse.jpg'),
          title: 'دانلود کاتالوگ۱'
        },
        {
          image: require('../../../../assets/images/product-images/malat.jpg'),
          title: 'دانلود کاتالوگ۲'
        },
        {
          image: require('../../../../assets/images/product-images/float-glass.jpg'),
          title: 'دانلود کاتالوگ۳۳۳۳۳'
        },
      ],
      videos: [
        {
          image: require('../../../../assets/images/product-images/material.jpg'),
          title: 'دانلود کاتالوگ'
        },
        {
          image: require('../../../../assets/images/product-images/masse.jpg'),
          title: 'دانلود کاتالوگ۱'
        },
        {
          image: require('../../../../assets/images/product-images/malat.jpg'),
          title: 'دانلود کاتالوگ۲'
        },
        {
          image: require('../../../../assets/images/product-images/float-glass.jpg'),
          title: 'دانلود کاتالوگ۳'
        },
      ]
    }
  },
  created() {
    this.$store.dispatch('glassManagement/getGlassArticles');
  },
  computed:{
    ...mapState({
      catalogue:state => state.glassManagement.glassHomeCatalogue,
      news:state => state.glassManagement.glassNews,
      articles:state => state.glassManagement.glassArticles,
    })
  }
}
</script>
<style scoped>
* {

  cursor: pointer;
}

.decor {
  padding: 0 4%;
  text-align: center;
  font-size: 30px;
  font-weight: 300;
  color: #222;
  letter-spacing: 1px;
  text-transform: uppercase;

  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  grid-template-rows: 27px 0;
  grid-gap: 20px;
  align-items: center;
}

.decor:after, .decor:before {
  content: " ";
  display: block;
  border-bottom: 1px solid #7BAD32;
  border-top: 1px solid #7BAD32;
  height: 5px;
  background-color: #e8e8e8;
}
.card-hover {
  transform: scaleX(1.5);
  transition: scaleX .7s;
}
.selected-item{
  display: flex;
  align-items: center;
  justify-content: start;
  text-align: right;
  padding: 8px 0;
  margin-right: 7%;
}
.selected-item:hover>h4{
  color: #7BAD32;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
}
.selected-item:hover>i{
  color: #7BAD32 !important;
}
.link-decor{
  color: #424242;
}

</style>